import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_SAP_CTA_ON_PETITION_SHOW = createFcmConfig('sap_cta_on_petition_show', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
